export default __webpack_public_path__ + "static/media/xx59.86fd2b8d.png";